import { render, staticRenderFns } from "./ConfigShare.vue?vue&type=template&id=f32dc214&"
import script from "./ConfigShare.vue?vue&type=script&lang=js&"
export * from "./ConfigShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
installComponents(component, {VList,VListItem,VListItemContent})
